module.exports = __webpack_public_path__ + "media/images/matching_top_mockups_2-a9251bd1bbefbcd8090510db74120be8.png";